import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListAllGitConfigsVariables = Types.Exact<{
  input: Types.ListGitConfigsInput;
}>;

export type ListAllGitConfigs = {
  listGitConfigs?: Types.Maybe<
    Pick<Types.ListGitConfigsResponse, 'cursor'> & {
      allGitConfigs?: Types.Maybe<{
        gitHubAppConfigs?: Types.Maybe<
          Array<
            Pick<
              Types.GitHubAppConfig,
              'organization' | 'repository' | 'readBranch' | 'installationID'
            > & {
              universalGitConfig: Pick<
                Types.UniversalGitConfig,
                'configID' | 'created' | 'updated' | 'lastPolled' | 'lastUploaded'
              >;
            }
          >
        >;
        genericGitConfigs?: Types.Maybe<
          Array<{
            universalGitConfig: Pick<
              Types.UniversalGitConfig,
              'configID' | 'created' | 'updated' | 'lastPolled' | 'lastUploaded'
            >;
          }>
        >;
      }>;
    }
  >;
};

export const ListAllGitConfigsDocument = gql`
  query ListAllGitConfigs($input: ListGitConfigsInput!) {
    listGitConfigs(input: $input) {
      cursor
      allGitConfigs {
        gitHubAppConfigs {
          organization
          repository
          readBranch
          installationID
          universalGitConfig {
            configID
            created
            updated
            lastPolled
            lastUploaded
          }
        }
        genericGitConfigs {
          universalGitConfig {
            configID
            created
            updated
            lastPolled
            lastUploaded
          }
        }
      }
    }
  }
`;

/**
 * __useListAllGitConfigs__
 *
 * To run a query within a React component, call `useListAllGitConfigs` and pass it any options that fit your needs.
 * When your component renders, `useListAllGitConfigs` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllGitConfigs({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListAllGitConfigs(
  baseOptions: Apollo.QueryHookOptions<ListAllGitConfigs, ListAllGitConfigsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAllGitConfigs, ListAllGitConfigsVariables>(
    ListAllGitConfigsDocument,
    options,
  );
}
export function useListAllGitConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAllGitConfigs, ListAllGitConfigsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAllGitConfigs, ListAllGitConfigsVariables>(
    ListAllGitConfigsDocument,
    options,
  );
}
export function useListAllGitConfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListAllGitConfigs, ListAllGitConfigsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListAllGitConfigs, ListAllGitConfigsVariables>(
    ListAllGitConfigsDocument,
    options,
  );
}
export type ListAllGitConfigsHookResult = ReturnType<typeof useListAllGitConfigs>;
export type ListAllGitConfigsLazyQueryHookResult = ReturnType<typeof useListAllGitConfigsLazyQuery>;
export type ListAllGitConfigsSuspenseQueryHookResult = ReturnType<
  typeof useListAllGitConfigsSuspenseQuery
>;
export type ListAllGitConfigsQueryResult = Apollo.QueryResult<
  ListAllGitConfigs,
  ListAllGitConfigsVariables
>;
export function mockListAllGitConfigs({
  data,
  variables,
  errors,
}: {
  data: ListAllGitConfigs;
  variables?: ListAllGitConfigsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ListAllGitConfigsDocument, variables },
    result: { data, errors },
  };
}
